import { LOGIN_FAILIED_STYLE } from "../../utils/GlobalConstants";
import { NO_ROLE_ERR } from "../../utils/GlobalMessageConstants";

const NoRole = () => {
  return <div style={LOGIN_FAILIED_STYLE}>{NO_ROLE_ERR} </div>;
};
export default NoRole;
